<template>
  <ejs-menu :items='menuItems' :select='selectItem'></ejs-menu>
</template>

<script>

export default {
  name: 'DynamicMenu',
  data() {
    return {
      menuItems: [],
      first_path: '',
      first_status: true
    };
  },
  mounted() {
    this.initAuth()
    this.initMenu()
  },
  methods: {
    initAuth() {
      const That = this;
      this.$axios.get('/lte/ems/auth/findModelFunction', {}).then((res) => {
        const auths = res.data;
        sessionStorage.setItem("authMap", JSON.stringify(auths));
      })
    },
    initMenu() {
      const That = this;
      this.$axios.get('/lte/ems/auth/findResourceByAuth', {}).then((res) => {
        const menus = [];
        const origin_res = res.data;
        let currentUrl = this.$route.path;
        That.menuItems = That.buildMenu(0, origin_res);
        if (currentUrl=='/main' && That.menuItems.length > 0) {
          this.$router.push({
            path: this.first_path
          });
          this.$router.go(1);
        }
      })
    },
    selectItem(args) {
      if(args.item.path === '/integrate/device'){
         window.open("../device");
         return;
      }
      this.$router.push(args.item.path);
    },
    buildMenu(pid, res) {
      const p_menu = [];
      const children = res[pid];
      if(!!children) {
        children.forEach((child, index) => {
          let menu = {text: child.nameStr};
          let c_menu = this.buildMenu(child.id, res);
          if(c_menu.length != 0) {
            menu['items'] = c_menu;
          }else {
            menu['path'] = child.url
            if (this.first_status) {
              this.first_path = child.url
              this.first_status = false
            }
          }
          p_menu.push(menu)
        })
      }
      return p_menu;
    }
  }
};

</script>
